import api from './axios/axiosInstance';

export interface RestaurantTable {
  _id: string;
  name: string;
  nameAr?: string;
  number: number;
  capacity: number;
  storeId: string;
  store: {
    _id: string;
    name: string;
    nameAr?: string;
  };
  status: 'AVAILABLE' | 'OCCUPIED' | 'RESERVED' | 'CLEANING';
  displayOrder: number;
  enabled?: boolean;
  createdAt: string;
  updatedAt: string;
  activeOrders: { _id: string; ID: string; total: number; createdAt: string; status: string }[];
  hasActiveOrders: boolean;
  qrCode?: string;
  categoryId?: string;
  category?: {
    name: string;
    nameAr: string;
    color: string;
    displayOrder: number;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
  };
}

export interface CreateTableDto {
  name: string;
  nameAr?: string;
  number: number;
  capacity: number;
  storeId: string;
  status: 'AVAILABLE' | 'OCCUPIED' | 'RESERVED' | 'CLEANING';
  qrCode?: string;
  displayOrder: number;
  enabled?: boolean;
}

export interface UpdateTableDto {
  name?: string;
  nameAr?: string;
  number?: number;
  capacity?: number;
  status?: 'AVAILABLE' | 'OCCUPIED' | 'RESERVED' | 'CLEANING';
  qrCode?: string;
  displayOrder?: number;
  enabled?: boolean;
}

const createTable = async (createTableDto: CreateTableDto) => {
  const response = await api.post('/tables', createTableDto);
  return response.data;
};

const getTables = async (storeId?: string): Promise<RestaurantTable[]> => {
  const response = await api.get('/tables', { params: { storeId } });
  return response.data;
};

const getTable = async (tableId: string): Promise<RestaurantTable> => {
  const response = await api.get(`/tables/${tableId}`);
  return response.data;
};

const updateTable = async (tableId: string, updateTableDto: UpdateTableDto) => {
  const response = await api.patch(`/tables/${tableId}`, updateTableDto);
  return response.data;
};

const deleteTable = async (tableId: string) => {
  const response = await api.delete(`/tables/${tableId}`);
  return response.data;
};

export { createTable, deleteTable, getTable, getTables, updateTable };
